import { Form, Input, Modal } from "antd";
import React, { useState } from "react";

interface ModalCreateBatchProps {
  open: boolean;
  onCancel?: () => void;
  onCreate?: (batchName: string, isForce?: boolean) => Promise<void> | void;
}

const ModalCreateBatch: React.FC<ModalCreateBatchProps> = ({
  open,
  onCancel,
  onCreate,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleOk = async (isForce = false) => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      await onCreate?.(values.batchName, isForce);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel?.();
  };

  return (
    <>
      <Modal
        open={open}
        title="Create a Batch"
        okText="Create Batch"
        onCancel={handleCancel}
        onOk={() => handleOk(false)}
        confirmLoading={loading}
      >
        <Form form={form} layout="vertical">
          <p>What would you like to name it, or should we use the export date and time?</p>
          <Form.Item name="batchName" label="Batch Name">
            <Input placeholder="Enter here" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default ModalCreateBatch;